import { useState, useEffect } from "react";
import { bulkCreateAttendance } from '../api/attendanceApi';
import {
  fetchEducationList,
  createEducation,
  updateEducation,
  deleteEducation,
  fetchEducationDetailList,
  createEducationDetail,
  deleteEducationDetail,
  fetchApplyMemberList
} from "../api/educationApi";
import { getCodeList } from "../api/codeApi";
import Toast from "../components/Toast";

const Badge = ({ children, color, onClick, style: extraStyle }) => {
  const colors = {
    blue: { bg: "#e8f4fd", text: "#1677ff", border: "#bae0ff" },
  };
  const c = colors[color] || colors.blue;
  return (
    <span
      style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 600, ...extraStyle }}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

// 교육 구분 색상 매핑 (F:집체, O:온라인, B:집체+온라인)
const EDU_TYPE_MAP = {
  F: { label: "집체",       bg: "#f6ffed", text: "#52c41a", border: "#b7eb8f" },
  O: { label: "온라인",     bg: "#e6f4ff", text: "#1677ff", border: "#91caff" },
  B: { label: "집체+온라인", bg: "#fff7e6", text: "#fa8c16", border: "#ffd591" },
};

const EduTypeBadge = ({ type }) => {
  const c = EDU_TYPE_MAP[type] || EDU_TYPE_MAP.F;
  return (
    <span style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>
      {c.label}
    </span>
  );
};

const RegisterModal = ({ onClose, onSave }) => {
  const currentYear = new Date().getFullYear().toString();
  const [form, setForm] = useState({ edu_name: "", edu_type: "F", start_dt: "", end_dt: "", edu_place: "", edu_time: "" });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleImgUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 1024 * 1024) { alert('이미지는 1MB 이하만 업로드 가능합니다.'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => set("img_data", ev.target.result);
    reader.readAsDataURL(file);
  };
  
  return (
    <div style={ms.overlay}>
      <div style={ms.modal}>
        <div style={ms.header}><span style={ms.title}>📋 교육 신규등록</span><button style={ms.closeBtn} onClick={onClose}>✕</button></div>
        <div style={ms.body}>
          <div style={ms.field}>
            <label style={ms.label}>교육명 <span style={{ color: "#ff4d4f" }}>*</span></label>
            <input style={ms.input} placeholder="교육명을 입력하세요" value={form.edu_name} onChange={e => set("edu_name", e.target.value)} />
          </div>
          <div style={ms.field}>
            <label style={ms.label}>구분 <span style={{ color: "#ff4d4f" }}>*</span></label>
            <select style={ms.input} value={form.edu_type} onChange={e => set("edu_type", e.target.value)}>
              <option value="F">집체</option>
              <option value="O">온라인</option>
              <option value="B">집체+온라인</option>
            </select>
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            {[{ label: "시작일자", key: "start_dt" }, { label: "종료일자", key: "end_dt" }].map(f => (
              <div key={f.key} style={{ ...ms.field, flex: 1 }}>
                <label style={ms.label}>{f.label} <span style={{ color: "#ff4d4f" }}>*</span></label>
                <input style={ms.input} type="date" value={form[f.key]} onChange={e => set(f.key, e.target.value)} />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <div style={{ ...ms.field, flex: 1 }}>
              <label style={ms.label}>장소</label>
              <input style={ms.input} placeholder="교육 장소 입력" value={form.edu_place} onChange={e => set("edu_place", e.target.value)} />
            </div>
            <div style={{ ...ms.field, flex: 1 }}>
              <label style={ms.label}>시간</label>
              <input style={ms.input} placeholder="예) 14:00 ~ 16:00" value={form.edu_time} onChange={e => set("edu_time", e.target.value)} />
            </div>
          </div>
          {/* 이미지 첨부 */}
          <div style={ms.field}>
            <label style={ms.label}>이미지 (선택, 1MB 이하)</label>
            <input type="file" accept="image/*" onChange={handleImgUpload} />
            {form.img_data && (
              <div style={{ marginTop: 8 }}>
                <img src={form.img_data} alt="미리보기"
                  style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8 }} />
                <button style={{ display: 'block', marginTop: 6, background: 'none', border: '1px solid #ffccc7', color: '#ff4d4f', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' }}
                  onClick={() => set("img_data", "")}>이미지 삭제</button>
              </div>
            )}
          </div>
        </div>
        <div style={ms.footer}>
          <button style={ms.cancelBtn} onClick={onClose}>취소</button>
          <button style={ms.saveBtn} onClick={() => onSave(form)}>등록</button>
        </div>
      </div>
    </div>
  );
};

const EditModal = ({ data, onClose, onSave }) => {
  const [form, setForm] = useState({ ...data });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleImgUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 1024 * 1024) { alert('이미지는 1MB 이하만 업로드 가능합니다.'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => set("img_data", ev.target.result);
    reader.readAsDataURL(file);
  };

  return (
    <div style={ms.overlay}>
      <div style={ms.modal}>
        <div style={ms.header}><span style={ms.title}>✏️ 교육 수정</span><button style={ms.closeBtn} onClick={onClose}>✕</button></div>
        <div style={ms.body}>
          <div style={{ display: "flex", gap: 12 }}>
            <div style={{ ...ms.field, flex: 1 }}>
              <label style={ms.label}>연도</label>
              <input style={{ ...ms.input, background: "#f0f0f0", color: "#aaa" }} value={form.edu_year} disabled />
            </div>
            <div style={{ ...ms.field, width: 80 }}>
              <label style={ms.label}>연번</label>
              <input style={{ ...ms.input, background: "#f0f0f0", color: "#aaa" }} value={form.seq_no} disabled />
            </div>
          </div>
          <div style={ms.field}>
            <label style={ms.label}>교육명 <span style={{ color: "#ff4d4f" }}>*</span></label>
            <input style={ms.input} value={form.edu_name} onChange={e => set("edu_name", e.target.value)} />
          </div>
          <div style={ms.field}>
            <label style={ms.label}>구분 <span style={{ color: "#ff4d4f" }}>*</span></label>
            <select style={ms.input} value={form.edu_type || "F"} onChange={e => set("edu_type", e.target.value)}>
              <option value="F">집체</option>
              <option value="O">온라인</option>
              <option value="B">집체+온라인</option>
            </select>
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            {[{ label: "시작일자", key: "start_dt" }, { label: "종료일자", key: "end_dt" }].map(f => (
              <div key={f.key} style={{ ...ms.field, flex: 1 }}>
                <label style={ms.label}>{f.label}</label>
                <input style={ms.input} type="date" value={form[f.key]} onChange={e => set(f.key, e.target.value)} />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <div style={{ ...ms.field, flex: 1 }}>
              <label style={ms.label}>장소</label>
              <input style={ms.input} placeholder="교육 장소 입력" value={form.edu_place || ""} onChange={e => set("edu_place", e.target.value)} />
            </div>
            <div style={{ ...ms.field, flex: 1 }}>
              <label style={ms.label}>시간</label>
              <input style={ms.input} placeholder="예) 14:00 ~ 16:00" value={form.edu_time || ""} onChange={e => set("edu_time", e.target.value)} />
            </div>
          </div>

          {/* 이미지 첨부 */}
          <div style={ms.field}>
            <label style={ms.label}>이미지 (선택, 1MB 이하)</label>
            <input type="file" accept="image/*" onChange={handleImgUpload} />
            {form.img_data && (
              <div style={{ marginTop: 8 }}>
                <img src={form.img_data} alt="미리보기"
                  style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8 }} />
                <button style={{ display: 'block', marginTop: 6, background: 'none', border: '1px solid #ffccc7', color: '#ff4d4f', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer' }}
                  onClick={() => set("img_data", "")}>이미지 삭제</button>
              </div>
            )}
          </div>
        </div>
        <div style={ms.footer}>
          <button style={ms.cancelBtn} onClick={onClose}>취소</button>
          <button style={ms.saveBtn} onClick={() => onSave(form)}>저장</button>
        </div>
      </div>
    </div>
  );
};

const DeleteModal = ({ onClose, onConfirm }) => (
  <div style={ms.overlay}>
    <div style={{ ...ms.modal, maxWidth: 360, textAlign: "center", padding: "40px 24px" }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
      <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>교육을 삭제하시겠습니까?</h3>
      <p style={{ fontSize: 13, color: "#999", margin: "0 0 24px" }}>삭제된 데이터는 복구할 수 없습니다.</p>
      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <button style={ms.cancelBtn} onClick={onClose}>취소</button>
        <button style={{ ...ms.saveBtn, background: "#ff4d4f" }} onClick={onConfirm}>삭제</button>
      </div>
    </div>
  </div>
);

const DetailPage = ({ item, onBack, onEdit, onDelete, isAdmin }) => {
  const [detailList, setDetailList]   = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [newEduDt, setNewEduDt]       = useState("");
  const [rangeStart, setRangeStart]   = useState("");  // 기간추가용 시작일자
  const [rangeEnd, setRangeEnd]       = useState("");  // 기간추가용 종료일자
  const [newEduPlace, setNewEduPlace] = useState("");  // 장소
  const [showDelDetail, setShowDelDetail] = useState(null);
  const [toast, setToast]                 = useState("");
  const [applyModal,     setApplyModal]     = useState(null);  // 클릭된 edu_dt
  const [applyMembers,   setApplyMembers]   = useState([]);
  const [applyLoading,   setApplyLoading]   = useState(false);
  const [bulkAttCnt, setBulkAttCnt] = useState(1);
  const [bulkSkipped, setBulkSkipped] = useState([]);

  const isOnline = item.edu_type === 'O';  // 구분이 온라인인지 여부

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  const loadDetailList = async () => {
    setDetailLoading(true);
    try {
      const res = await fetchEducationDetailList(item.edu_year, item.seq_no);
      if (res.success) setDetailList(res.data);
    } catch (err) {}
    finally { setDetailLoading(false); }
  };

  useEffect(() => { loadDetailList(); }, [item]);

  const handleAddDetail = async () => {
    if (!newEduDt) return;
    const res = await createEducationDetail(item.edu_year, item.seq_no, newEduDt, newEduPlace);
    if (res.success) {
      setNewEduDt("");
      loadDetailList();
      showToast("✅ 세부일정이 등록되었습니다.");
    } else {
      showToast(`⚠️ ${res.message}`);
    }
  };

  // 기간추가 - 토/일 제외하고 평일만 자동 생성 (온라인 구분 전용)
  const handleAddRange = async () => {
    if (!rangeStart || !rangeEnd) { showToast("⚠️ 시작일자와 종료일자를 입력해주세요."); return; }
    if (rangeStart > rangeEnd) { showToast("⚠️ 시작일자는 종료일자보다 빠를 수 없습니다."); return; }

    const dates = [];
    const cur = new Date(rangeStart);
    const end = new Date(rangeEnd);
    while (cur <= end) {
      const day = cur.getDay();
      if (day !== 0 && day !== 6) {
        dates.push(cur.toISOString().slice(0, 10));
      }
      cur.setDate(cur.getDate() + 1);
    }

    if (dates.length === 0) { showToast("⚠️ 평일이 포함된 기간을 선택해주세요."); return; }

    let successCnt = 0;
    let skipCnt = 0;
    for (const dt of dates) {
      const res = await createEducationDetail(item.edu_year, item.seq_no, dt, newEduPlace);
      if (res.success) successCnt++;
      else skipCnt++;
    }

    setRangeStart("");
    setRangeEnd("");
    loadDetailList();
    showToast(`✅ ${successCnt}건 등록 완료${skipCnt > 0 ? ` (중복 ${skipCnt}건 제외)` : ""}`);
  };

  const handleDeleteDetail = async (edu_dt) => {
    const res = await deleteEducationDetail(item.edu_year, item.seq_no, edu_dt);
    if (res.success) {
      setShowDelDetail(null);
      loadDetailList();
    }
  };

  const handleApplyCntClick = async (edu_dt, cnt) => {
    if (cnt === 0) return;
    setApplyModal(edu_dt);
    setApplyLoading(true);
    try {
      const res = await fetchApplyMemberList(item.edu_year, item.seq_no, edu_dt);
      if (res.success) setApplyMembers(res.data);
    } catch (err) { showToast('❌ 신청자 목록 조회 실패'); }
    finally { setApplyLoading(false); }
  };

  const handleApplyExcelDownload = () => {
    import("xlsx").then((XLSX) => {
      const headers = ["신청일자", "소속", "부서", "사번", "이름", "전화번호"];
      const rows = applyMembers.map(r => [
        r.apply_dt, r.division_sub_name || '-', r.department || '-',
        r.emp_no, r.name, r.phone || '-'
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      ws['!cols'] = [{ wch: 14 }, { wch: 16 }, { wch: 16 }, { wch: 12 }, { wch: 12 }, { wch: 16 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '신청자목록');
      XLSX.writeFile(wb, `교육신청자_${item.edu_year}-${item.seq_no}_${applyModal}.xlsx`);
    });
  };

  // 교육 출석부 일괄생성
  const handleBulkCreate = async () => {
    if (detailList.length === 0) {
      showToast('❌ 세부일정이 없습니다.');
      return;
    }
    setBulkSkipped([]);  // ← 초기화
    try {
      const res = await bulkCreateAttendance({
        edu_year : item.edu_year,
        seq_no   : item.seq_no,
        edu_name : item.edu_name,
        att_cnt  : bulkAttCnt,
        details  : detailList.map(d => ({ edu_dt: d.edu_dt }))
      });
      if (res.success) {
        showToast(`✅ ${res.message}`);
        if (res.skippedMsg && res.result.skipped.length > 0) {
          setBulkSkipped(res.result.skipped);  // ← 건너뛴 일정 저장
        }
      } else {
        showToast(`❌ ${res.message}`);
      }
    } catch (err) {
      showToast('❌ 출석부 생성 실패');
    }
  };

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />
      <button style={styles.backBtn} onClick={onBack}>← 목록으로</button>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageTitle}>📋 교육 상세정보</h1>
      </div>

      {/* 상단 - 교육 기본정보 */}
      <div style={{ ...styles.card, padding: 32 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1a1a2e", margin: 0 }}>{item.edu_name}</h2>
          <EduTypeBadge type={item.edu_type} />
        </div>

        {item.img_data && (
          <div style={{ marginBottom: 24 }}>
            <img src={item.img_data} alt="교육 이미지"
              style={{ maxWidth: '100%', maxHeight: 320, borderRadius: 12, objectFit: 'contain' }} />
          </div>
        )}

        <div style={detailStyles.grid}>
          {[
            { label: "연도",        value: `${item.edu_year}년` },
            { label: "연번",        value: `${item.seq_no}` },
            { label: "시작일자",    value: item.start_dt },
            { label: "종료일자",    value: item.end_dt },
            { label: "장소",        value: item.edu_place || "-" },
            { label: "시간",        value: item.edu_time  || "-" },
            { label: "등록일자",    value: item.reg_dt    || "-" },
            { label: "최초 등록자", value: item.reg_emp_no },
            { label: "수정일자",    value: item.mod_dt    || "-" },
            { label: "최종 수정자", value: item.mod_emp_no },
          ].map(f => (
            <div key={f.label} style={detailStyles.field}>
              <span style={detailStyles.fieldLabel}>{f.label}</span>
              <span style={detailStyles.fieldValue}>{f.value}</span>
            </div>
          ))}
        </div>
        {isAdmin && (
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 32, paddingTop: 20, borderTop: "1px solid #f0f0f0" }}>
            <button style={styles.editBtn} onClick={onEdit}>✏️ 수정</button>
            <button style={styles.deleteBtn} onClick={onDelete}>🗑 삭제</button>
          </div>
        )}
      </div>

      {/* 하단 - 세부일정 */}
      <div style={{ ...styles.card, marginTop: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>📅 세부일정</h3>
          <span style={styles.statBadge}>총 {detailList.length}건</span>
        </div>

        {/* 등록 입력 (관리자만) */}
        {isAdmin && (
          <div style={{ marginBottom: 16, display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
              {/* 장소 - 왼쪽 배치 */}
              <input
                type="text"
                placeholder="장소 입력"
                style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e", width: 140 }}
                value={newEduPlace}
                onChange={e => setNewEduPlace(e.target.value)}
              />

              {/* 단일 일정 추가 */}
              <input
                type="date"
                style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e" }}
                value={newEduDt}
                onChange={e => setNewEduDt(e.target.value)}
              />
              <button style={{ ...styles.editBtn, padding: "8px 14px", fontSize: 13 }} onClick={handleAddDetail}>
                일정 추가
              </button>

              {/* 기간 추가 (평일만 자동생성) */}
              <input
                type="date"
                style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e" }}
                value={rangeStart}
                onChange={e => setRangeStart(e.target.value)}
                placeholder="시작일자"
              />
              <span style={{ color: "#aaa" }}>~</span>
              <input
                type="date"
                style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e" }}
                value={rangeEnd}
                onChange={e => setRangeEnd(e.target.value)}
                placeholder="종료일자"
              />
              <button
                style={{ background: "#fff", border: "1.5px solid #722ed1", color: "#722ed1", borderRadius: 8, padding: "8px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                onClick={handleAddRange}
              >
                기간 추가
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#888" }}>
              💡 기간 지정 시 토/일을 제외한 일정이 자동 생성됩니다.
            </div>
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#1677ff", borderLeft: "3px solid #1677ff", paddingLeft: 10 }}>
            세부 일정
          </div>
          {isAdmin && (
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              출석회수
              <select
                style={{ border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "6px 12px", fontSize: 13, outline: "none", background: "#fff", cursor: "pointer" }}
                value={bulkAttCnt}
                onChange={e => setBulkAttCnt(Number(e.target.value))}>
                {[1,2,3,4,5].map(n => (
                  <option key={n} value={n}>{n}회</option>
                ))}
              </select>
              <button
                style={{ background: "#fff", border: "1.5px solid #722ed1", color: "#722ed1", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                onClick={handleBulkCreate}>
                📋 출석부 일괄생성
              </button>
            </div>
          )}
        </div>

       {/* 세부일정 목록 */}
        <div style={{ border: "1px solid #f0f0f0", borderRadius: 10, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: "0.6fr 1.3fr 1.2fr 1fr 1.3fr 0.8fr", padding: "10px 16px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" }}>
            {["No", "교육일자", "장소", "신청자수", "등록자", isAdmin ? "삭제" : ""].map((h, i) => (
              <div key={i} style={{ fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
            ))}
          </div>
          {detailLoading ? (
            <div style={styles.empty}>⏳ 불러오는 중...</div>
          ) : detailList.length === 0 ? (
            <div style={styles.empty}>등록된 세부일정이 없습니다.</div>
          ) : detailList.map((d, i) => {
            const applyCnt   = Number(d.apply_cnt) || 0;
            const canDelete  = applyCnt === 0;

            return (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "0.6fr 1.3fr 1.2fr 1fr 1.3fr 0.8fr", padding: "12px 16px", borderBottom: "1px solid #f5f5f5", alignItems: "center" }}>
                <div style={{ fontSize: 14, color: "#888" }}>{i + 1}</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>{d.edu_dt}</div>
                <div style={{ fontSize: 13, color: "#666" }}>{d.edu_place || "-"}</div>
                <div>
                  {applyCnt > 0
                    ? <Badge color="blue" style={{ cursor: "pointer" }} onClick={() => handleApplyCntClick(d.edu_dt, applyCnt)}>
                        {applyCnt}명
                      </Badge>
                    : <span style={{ fontSize: 13, color: "#bbb" }}>0명</span>
                  }
                </div>
                <div style={{ fontSize: 13, color: "#888" }}>{d.reg_emp_no}</div>
                {isAdmin && (
                  <div>
                    <button
                      style={{
                        background: canDelete ? "#fff2f0" : "#f5f5f5",
                        border: `1px solid ${canDelete ? "#ffccc7" : "#e0e0e0"}`,
                        color: canDelete ? "#ff4d4f" : "#bbb",
                        borderRadius: 6, padding: "4px 10px", fontSize: 12,
                        cursor: canDelete ? "pointer" : "not-allowed"
                      }}
                      onClick={() => canDelete && setShowDelDetail(d.edu_dt)}
                      disabled={!canDelete}
                      title={!canDelete ? "신청자가 있어 삭제할 수 없습니다." : ""}
                    >삭제</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {bulkSkipped.length > 0 && (
        <div style={{ marginTop: 10, padding: "10px 14px", background: "#fff7e6", border: "1px solid #ffd591", borderRadius: 8, fontSize: 13, color: "#d46b08" }}>
          ⚠️ 이미 출석부가 존재하여 건너뛴 일정: {bulkSkipped.join(', ')}
        </div>
      )}

      {/* 신청자 목록 모달 */}
      {applyModal && (
        <div style={ms.overlay}>
          <div style={{ ...ms.modal, maxWidth: 700, padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e", margin: 0 }}>
                👥 신청자 목록 - {applyModal}
              </h3>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  style={{ background: "#fff", border: "1.5px solid #52c41a", color: "#52c41a", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}
                  onClick={handleApplyExcelDownload}>
                  📊 엑셀 다운로드
                </button>
                <button style={{ background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" }}
                  onClick={() => { setApplyModal(null); setApplyMembers([]); }}>✕</button>
              </div>
            </div>

            {/* 목록 */}
            <div style={{ maxHeight: 480, overflowY: "auto" }}>
              {applyLoading ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#bbb" }}>⏳ 불러오는 중...</div>
              ) : (
                <>
                  <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1.5fr 1.5fr 1fr 1fr 1.5fr", padding: "10px 24px", background: "#f8faff", borderBottom: "1px solid #e8f0fe" }}>
                    {["신청일자", "소속", "부서", "사번", "이름", "전화번호"].map(h => (
                      <div key={h} style={{ fontSize: 12, fontWeight: 700, color: "#888" }}>{h}</div>
                    ))}
                  </div>
                  {applyMembers.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#bbb", fontSize: 14 }}>신청자가 없습니다.</div>
                  ) : applyMembers.map((r, i) => (
                    <div key={i} style={{ display: "grid", gridTemplateColumns: "1.2fr 1.5fr 1.5fr 1fr 1fr 1.5fr", padding: "12px 24px", borderBottom: "1px solid #f5f5f5", alignItems: "center" }}>
                      <div style={{ fontSize: 13, color: "#888" }}>{r.apply_dt}</div>
                      <div style={{ fontSize: 13, color: "#1a1a2e" }}>{r.division_sub_name || '-'}</div>
                      <div style={{ fontSize: 13, color: "#1a1a2e" }}>{r.department || '-'}</div>
                      <div style={{ fontSize: 13, color: "#1a1a2e" }}>{r.emp_no}</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>{r.name}</div>
                      <div style={{ fontSize: 13, color: "#888" }}>{r.phone || '-'}</div>
                    </div>
                  ))}
                </>
              )}
            </div>

            <div style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", textAlign: "right" }}>
              <span style={{ fontSize: 13, color: "#888", marginRight: 16 }}>총 {applyMembers.length}명</span>
              <button style={ms.cancelBtn} onClick={() => { setApplyModal(null); setApplyMembers([]); }}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {/* 세부일정 삭제 확인 모달 */}
      {showDelDetail && (
        <div style={ms.overlay}>
          <div style={{ ...ms.modal, maxWidth: 360, textAlign: "center", padding: "40px 24px" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" }}>일정을 삭제하시겠습니까?</h3>
            <p style={{ fontSize: 14, color: "#1677ff", fontWeight: 600, margin: "0 0 6px" }}>{showDelDetail}</p>
            <p style={{ fontSize: 13, color: "#999", margin: "0 0 24px" }}>삭제된 데이터는 복구할 수 없습니다.</p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button style={ms.cancelBtn} onClick={() => setShowDelDetail(null)}>취소</button>
              <button style={{ ...ms.saveBtn, background: "#ff4d4f" }} onClick={() => handleDeleteDetail(showDelDetail)}>삭제</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default function EducationPage({ onLogout, userLevel }) {
  const isAdmin = ['0', '1'].includes(userLevel);
  const [page, setPage] = useState("list");
  const [list, setList] = useState([]);          // ← 빈 배열로 시작
  const [loading, setLoading] = useState(false); // ← 로딩 상태 추가
  const [selected, setSelected] = useState(null);
  const [showRegister, setShowRegister] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [toast, setToast] = useState("");
  const [search, setSearch] = useState("");
  const currentYear = new Date().getFullYear().toString();
  const [yearFilter, setYearFilter] = useState(currentYear);
  const [currentPage, setCurrentPage] = useState(1);
  const [yearList, setYearList] = useState([]);

  const PAGE_SIZE = 5;

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  // 목록 조회
  const loadList = async (edu_year) => {
    setLoading(true);
    try {
      const res = await fetchEducationList(edu_year);
      if (res.success) setList(res.data);
      else if (res.message === '토큰이 만료되었습니다. 다시 로그인해주세요.') onLogout();
    } catch (err) {
      showToast("❌ 목록 조회 실패");
    } finally {
      setLoading(false);
    }
  };

  // yearFilter 변경 시 자동으로 재조회
  useEffect(() => { loadList(yearFilter); }, [yearFilter]);

  useEffect(() => {
    setYearList(getCodeList('YEAR_LIST'));
  }, []);

  const filtered = list.filter(r =>
    (!search || r.edu_name.includes(search)) &&
    (!yearFilter || r.edu_year === yearFilter)
  );
  const paginated = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);

  // 등록
  const handleRegister = async (form) => {
    if (!form.edu_name || !form.start_dt || !form.end_dt) {
      showToast("⚠️ 모든 항목을 입력해주세요."); return;
    }
    try {
      const edu_year = new Date().getFullYear().toString();
      const res = await createEducation({ ...form, edu_year });
      if (res.success) {
        await loadList(yearFilter);  // ← yearFilter 전달해서 재조회!
        setShowRegister(false);
        showToast("✅ 교육이 등록되었습니다.");
      } else {
        showToast(`❌ ${res.message}`);
      }
    } catch (err) {
      showToast("❌ 등록 실패");
    }
  };

  // 수정
  const handleEdit = async (form) => {
    try {
      const res = await updateEducation(selected.edu_year, selected.seq_no, form);
      if (res.success) {
        await loadList(yearFilter);  // ← yearFilter 전달해서 재조회!
        setSelected({ ...selected, ...form });
        setShowEdit(false);
        showToast("✅ 교육이 수정되었습니다.");
      } else {
        showToast(`❌ ${res.message}`);
      }
    } catch (err) {
      showToast("❌ 수정 실패");
    }
  };

  // 삭제
  const handleDelete = async () => {
    console.log('삭제 selected 객체:', selected);
    try {
      const res = await deleteEducation(selected.edu_year, selected.seq_no);
      if (res.success) {
        await loadList(yearFilter);  // ← yearFilter 전달해서 재조회!
        setShowDelete(false);
        setPage("list");
        showToast("✅ 교육이 삭제되었습니다.");
      } else {
        showToast(`❌ ${res.message}`);
      }
    } catch (err) {
      showToast("❌ 삭제 실패");
    }
  };

  if (page === "detail" && selected) {
    return (
      <>
        <Toast msg={toast} />
        <DetailPage
          item={selected}
          onBack={() => setPage("list")}
          onEdit={() => setShowEdit(true)}
          onDelete={() => setShowDelete(true)}
          isAdmin={isAdmin}
        />
        {showEdit && <EditModal data={selected} onClose={() => setShowEdit(false)} onSave={handleEdit} />}
        {showDelete && <DeleteModal onClose={() => setShowDelete(false)} onConfirm={handleDelete} />}
      </>
    );
  }

  return (
    <div style={styles.wrap}>
      <Toast msg={toast} />
      <div style={styles.pageHeader}>
        <div>
          <h1 style={styles.pageTitle}>📚 조합원 교육 관리</h1>
        </div>
        <div style={styles.statBadge}>총 {filtered.length}건</div>
      </div>

      <div style={styles.filterCard}>
        <input style={styles.searchInput} placeholder="🔍 교육명 검색" value={search}
          onChange={e => { setSearch(e.target.value); setCurrentPage(1); }} />
        <select style={styles.select} value={yearFilter}
          onChange={e => { setYearFilter(e.target.value); setCurrentPage(1); }}>
          <option value="">전체 연도</option>
          {yearList.map(y => (
            <option key={y.code} value={y.code}>{y.code_nm}</option>
          ))}
        </select>
      </div>

      <div style={styles.card}>
        {loading ? (
          <div style={styles.empty}>⏳ 불러오는 중...</div>
        ) : paginated.length === 0 ? (
          <div style={styles.empty}>등록된 교육이 없습니다.</div>
        ) : paginated.map((item, i) => (
          <div key={i} style={styles.listItem}
            onClick={() => { setSelected(item); setPage("detail"); }}
            onMouseEnter={e => e.currentTarget.style.background = "#f8faff"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
            <div style={styles.listLeft}>
              <Badge color="blue">{item.edu_year}-{item.seq_no}</Badge>
              <EduTypeBadge type={item.edu_type} />
              <span style={styles.eduName}>{item.edu_name}</span>
            </div>
            <div style={styles.listRight}>
              <span style={styles.dateRange}>📅 {item.start_dt} ~ {item.end_dt}</span>
              <span style={styles.arrow}>›</span>
            </div>
          </div>
        ))}
        {totalPages > 1 && (
          <div style={styles.pagination}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
              <button key={p} style={{ ...styles.pageBtn, ...(p === currentPage ? styles.pageBtnActive : {}) }}
                onClick={() => setCurrentPage(p)}>{p}</button>
            ))}
          </div>
        )}
      </div>
      {isAdmin && (
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <button style={styles.registerBtn} onClick={() => setShowRegister(true)}>＋ 신규등록</button>
      </div>
      )}
      {showRegister && <RegisterModal onClose={() => setShowRegister(false)} onSave={handleRegister} />}
    </div>
  );
}

const styles = {
  wrap: { background: "#f5f7fa", padding: 24, fontFamily: "'Noto Sans KR', sans-serif" },
  pageHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 },
  pageTitle: { fontSize: 22, fontWeight: 800, color: "#1a1a2e", margin: "0 0 4px" },
  pageSub: { fontSize: 12, color: "#aaa", margin: 0 },
  statBadge: { background: "#e8f4fd", color: "#1677ff", border: "1px solid #bae0ff", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600 },
  filterCard: { background: "#fff", borderRadius: 12, padding: "14px 16px", marginBottom: 12, display: "flex", gap: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
  searchInput: { flex: 1, border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 14px", fontSize: 14, outline: "none", background: "#fafafa" },
  select: { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 14px", fontSize: 14, outline: "none", background: "#fff", cursor: "pointer" },
  card: { background: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", overflow: "hidden", padding: "20px 24px" },
  listItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", borderBottom: "1px solid #f5f5f5", cursor: "pointer", transition: "background 0.15s" },
  listLeft: { display: "flex", alignItems: "center", gap: 12 },
  eduName: { fontSize: 15, fontWeight: 600, color: "#1a1a2e" },
  listRight: { display: "flex", alignItems: "center", gap: 12 },
  dateRange: { fontSize: 13, color: "#888" },
  arrow: { fontSize: 20, color: "#ccc", fontWeight: 300 },
  empty: { textAlign: "center", padding: "60px 0", color: "#bbb", fontSize: 14 },
  pagination: { display: "flex", justifyContent: "center", gap: 6, padding: "14px 0" },
  pageBtn: { width: 30, height: 30, borderRadius: 6, border: "1px solid #e0e0e0", background: "#fff", cursor: "pointer", fontSize: 13, color: "#666" },
  pageBtnActive: { background: "#1677ff", color: "#fff", border: "1px solid #1677ff" },
  registerBtn: { background: "linear-gradient(135deg, #1677ff, #4096ff)", color: "#fff", border: "none", borderRadius: 10, padding: "12px 24px", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 12px rgba(22,119,255,0.35)" },
  backBtn: { background: "none", border: "1px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", fontSize: 13, color: "#666", cursor: "pointer", marginBottom: 12, display: "block" },
  editBtn: { background: "#fff", border: "1.5px solid #1677ff", color: "#1677ff", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
  deleteBtn: { background: "#fff2f0", border: "1.5px solid #ff4d4f", color: "#ff4d4f", borderRadius: 8, padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
};

const detailStyles = {
  grid        : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  field       : { display: "flex", flexDirection: "row", alignItems: "center", gap: 0, background: "#fafafa", borderRadius: 8, border: "1.5px solid #e0e0e0", overflow: "hidden" },
  fieldLabel  : { fontSize: 13, fontWeight: 600, color: "#666", background: "#f0f4ff", padding: "12px 16px", minWidth: 120, whiteSpace: "nowrap", borderRight: "1.5px solid #e0e0e0" },
  fieldValue  : { fontSize: 14, color: "#1a1a2e", padding: "12px 16px" },
};

const ms = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" },
  modal: { background: "#fff", borderRadius: 16, width: "100%", maxWidth: 460, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden", maxHeight: "90vh", display: "flex", flexDirection: "column" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #f0f0f0" },
  title: { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  closeBtn: { background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" },
  body: { padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14, overflowY: "auto", flex: 1 },
  field: { display: "flex", flexDirection: "column", gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: "#444" },
  input: { border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e" },
  footer: { display: "flex", gap: 10, justifyContent: "flex-end", padding: "16px 24px", borderTop: "1px solid #f0f0f0", flexShrink: 0 },
  cancelBtn: { background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" },
  saveBtn: { background: "linear-gradient(135deg, #1677ff, #4096ff)", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
};
